import { camelCase, mapKeys, snakeCase } from 'lodash';

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0 || bytes < 0 || bytes == null) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

export const slugify = (string) => {
  const a =
    'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
  const b =
    'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '') // Removes spaces
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/-+/g, '') // Removes -
    .substring(0, 16);
};

export const snakeCaseKeys = (obj) => mapKeys(obj, (v, key) => snakeCase(key));

export const camelCaseKeys = (obj) => mapKeys(obj, (v, key) => camelCase(key));

export const dollarsToCents = (dollarAmount) =>
  parseInt((dollarAmount * 100).toFixed(), 10);

export const centsToDollars = (centsAmount) => (centsAmount / 100).toFixed(2);

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const toTitleCase = (string) => {
  return string
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ');
};
